function text(value) {
  return typeof value === 'string' ? value.trim() : ''
}

function deepFreeze(value) {
  if (!value || typeof value !== 'object' || Object.isFrozen(value)) return value
  Object.values(value).forEach(deepFreeze)
  return Object.freeze(value)
}

/** Select the immutable Creator prompt after an optional Director result. */
export function resolveImageCreatorPrompt({ director = null, originalPrompt = '' } = {}) {
  const normalizedOriginalPrompt = text(originalPrompt)
  const directorPrompt = director && typeof director === 'object'
    ? text(director.prompt)
    : ''
  return deepFreeze({
    activeDirector: directorPrompt ? director : null,
    originalPrompt: normalizedOriginalPrompt,
    submitPrompt: directorPrompt || normalizedOriginalPrompt
  })
}

export function resolveImageDirectorPrompt(prompt = '') {
  return text(prompt)
}

/**
 * Append seller-specific context after the picture-site base prompt. The base
 * prompt is always retained verbatim as the first section.
 */
export function appendSellerPromptExtensions(basePrompt = '', extensions = {}) {
  const base = text(basePrompt)
  const values = Array.isArray(extensions)
    ? extensions
    : [
        ...(Array.isArray(extensions?.technicalLines) ? extensions.technicalLines : []),
        ...(Array.isArray(extensions?.businessLines) ? extensions.businessLines : []),
        ...(Array.isArray(extensions?.sellerLines) ? extensions.sellerLines : [])
      ]
  const lines = values.map(text).filter(Boolean)
  return [base, ...lines].filter(Boolean).join('\n')
}
